module.exports = __webpack_public_path__ + "static/media/index_copernicus.b047a0f7.png";